export const getStyles = (tabWidth: string, hasBanner: boolean) => {
  const styles = {
    root: {
      position: "fixed",
      top: hasBanner ? 100 : 60,
      bottom: 0,
      right: tabWidth,
      zIndex: 100,
    },
    active: {
      borderRadius: 0,
      borderRight: `3px solid #3E633E`,
    },
    icon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#6B7770",
      py: 1,
    },
  };
  return styles;
};
